export class SnapshotSelector {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mode",
            "baseName": "mode",
            "type": "SnapshotSelectorMode",
            "format": ""
        },
        {
            "name": "_from",
            "baseName": "from",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "to",
            "baseName": "to",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "cleanOnly",
            "baseName": "cleanOnly",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "pick",
            "baseName": "pick",
            "type": "SnapshotRangePick",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotSelector.attributeTypeMap;
    }
    constructor() {
    }
}
